<template>
  <div>
    <!-- <div class="cornerbadge">
      <h1 style="font-weight: 900">
        7 DAY FREE TRIAL
        <span class="body-2 font-weight-black">
          cancel anytime
        </span>
        
      </h1>
      <p @click="goToPortal" class="manage">Manage subscription</p>
    </div> -->
    <v-card dark flat :height="computedHeight" tile elevation="4">
      <div class="pa-md-5">
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </div>
      <v-col cols="12" md="12" sm="12">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          class="logo mx-auto"
          width="350"
          contain
        />
      </v-col>

      <v-col cols="8" md="3" sm="4" class="mx-auto">
        <p class="text-center ml-4 text-h6 font-weight-bold">
          Upgrade & Get Access to All Features
        </p>
      </v-col>

      <!--//? pricing toggle -->
      <v-col cols="8" md="3" sm="4" class="mx-auto mb-5 mt-n5 text-center">
        <v-btn-toggle class="ml-md-7 ml-n4" v-model="toggle_exclusive">
          <v-btn> Weekly </v-btn>

          <v-btn> Monthly </v-btn>

          <v-btn> Yearly </v-btn>
        </v-btn-toggle>
      </v-col>
      <!--//? pricing toggle ends...-->

      <v-col cols="12" md="9" sm="10" class="mt-n6 mx-auto">
        <v-row class="style-1" justify="center">
          <!--//* free -->
          <!-- <v-col cols="12" md="4" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              max-width="300"
              :disabled="planType === 'Free' ? true : false"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">
                  Free
                </p>
               
                <p class="text-h6 font-weight-bold text-center">
                  $0.<sup>00</sup>
                </p> -->

          <!--//* offers -->
          <!-- <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelFree"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial;"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-decagram
                      </v-icon>
                      <v-icon v-else color="red">
                        mdi-close-outline
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list> -->

          <!--//* offers ends... -->
          <!-- </v-card-text>
              <v-card-actions>
                <v-col class="text-center mt-n10">
                  <v-btn depressed color="success" @click="freeModel">
                    Try for free
                  </v-btn>
                </v-col>
              </v-card-actions> -->
          <!-- </v-card> -->
          <!-- </v-col> -->

          <!--//* premium -->
          <!-- <v-col cols="12" md="4" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              max-width="300"
              :disabled="planType === 'Premium' ? true : false"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">
                  Premium
                </p>
                <p
                  v-if="this.toggle_exclusive === 0"
                  class="text-h6 font-weight-bold text-center"
                >
                  $6.<sup>99</sup>
                </p>
                <p
                  v-else-if="this.toggle_exclusive === 1"
                  class="text-h6 font-weight-bold text-center"
                >
                  $29.<sup>99</sup>
                </p>
                <p
                  v-else-if="this.toggle_exclusive === 2"
                  class="text-h6 font-weight-bold text-center"
                >
                  $199.<sup>99</sup>
                </p>

                <!--//? offers -->
          <!-- <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelPremium"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial;"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-decagram
                      </v-icon>
                      <v-icon v-else color="red">
                        mdi-close-outline
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list> -->

          <!-- offers ends... -->
          <!-- </v-card-text>
              <v-card-actions>
                <v-col class="text-center mt-n10">
                  <v-btn depressed color="success" @click="premiumModel">
                    Get Started
                  </v-btn>
                </v-col>
              </v-card-actions>
             
            </v-card>
          </v-col> -->

          <!--//* platinum -->
          <v-col cols="12" md="4" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              style="border: 5px solid #76ff03"
              max-width="300"
              :disabled="planType === 'Platinum' ? true : false"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">Platinum</p>
                <!-- <p class="text-center">
                  <del class="text-h5">$49.<sup>99</sup></del>
                </p> -->
                <p
                  v-if="this.toggle_exclusive === 0"
                  class="text-h6 font-weight-bold text-center"
                >
                  $9.<sup>99</sup>
                </p>
                <p
                  v-else-if="this.toggle_exclusive === 1"
                  class="text-h6 font-weight-bold text-center"
                >
                  $29.<sup>99</sup>
                </p>
                <p
                  v-else-if="this.toggle_exclusive === 2"
                  class="text-h6 font-weight-bold text-center"
                >
                  $299.<sup>99</sup>
                </p>

                <!-- offers -->
                <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelPlatinum"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-decagram
                      </v-icon>
                      <v-icon v-else color="red"> mdi-close-outline </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <!-- offers ends... -->
              </v-card-text>
              <v-card-actions>
                <v-col class="text-center mt-n10">
                  <v-btn depressed color="success" @click="platinumModel">
                    Get Started
                  </v-btn>
                </v-col>
              </v-card-actions>
              <!-- <p class="text-center font-weight-bold caption mt-n5">
                cancel anytime
              </p> -->
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <!-- service -->
    <v-col>
      <p class="text-center text-subtitle-1 font-weight-medium">SERVICING</p>
    </v-col>

    <v-row justify="center">
      <v-spacer></v-spacer>
      <!-- draftkings -->
      <v-col cols="6" md="3" sm="4" class="mt-n7">
        <v-img
          src="/img/draftkings-logo.png"
          class="logo mx-auto mt-n10"
          height="150"
          width="150"
          contain
        />
      </v-col>

      <!-- fanduel -->
      <v-col cols="6" md="3" sm="4" class="mt-n7">
        <v-img
          src="/img/fanduel-logo.png"
          class="logo mx-auto mt-n10"
          height="150"
          width="150"
          contain
        />
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <!-- service -->
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "upgradePlan",
  title: "Fantasy Lineups Upgrade Plan",
  data() {
    return {
      toggle_exclusive: 1,
      planType: this.$store.state?.userModule?.userState?.plantype,

      priceModelFree: [
        {
          title: "Access to NFL,NHL,NBA,MLB",
          isAvailable: true,
        },

        {
          title: "Export Lineups Into CSV",
          isAvailable: true,
        },

        {
          title: "# of Optimizer Lineups",
          isAvailable: true,
          subtitle: "3",
        },

        {
          title: "# of Builds",
          isAvailable: true,
          subtitle: "1",
        },

        {
          title: "Insights",
          isAvailable: true,
        },

        {
          title: "Access to Our Projections",
          isAvailable: false,
        },

        {
          title: "Team Stack",
          isAvailable: false,
        },

        {
          title: "Min/Max Exposure",
          isAvailable: false,
        },

        {
          title: "Import / Export Projections",
          isAvailable: false,
        },

        {
          title: "Prop Analyzer",
          isAvailable: false,
        },

        {
          title: "Top Plays",
          isAvailable: false,
        },
      ],

      priceModelPremium: [
        {
          title: "Access to NFL,NHL,NBA,MLB",
          isAvailable: true,
        },

        {
          title: "Export Lineups Into CSV",
          isAvailable: true,
        },

        {
          title: "# of Optimizer Lineups",
          isAvailable: true,
          subtitle: "150",
        },

        {
          title: "# of Builds",
          isAvailable: true,
          subtitle: "Unlimited",
        },

        {
          title: "Insights",
          isAvailable: true,
        },

        {
          title: "Access to Our Projections",
          isAvailable: true,
        },

        {
          title: "Team Stack",
          isAvailable: true,
        },

        {
          title: "Min/Max Exposure",
          isAvailable: true,
        },

        {
          title: "Import / Export Projections",
          isAvailable: true,
        },

        {
          title: "Prop Analyzer",
          isAvailable: true,
        },

        {
          title: "Top Plays",
          isAvailable: false,
        },
      ],

      priceModelPlatinum: [
        {
          title: "Access to NFL,NHL,NBA,MLB",
          isAvailable: true,
        },

        {
          title: "Export Lineups Into CSV",
          isAvailable: true,
        },

        {
          title: "# of Optimizer Lineups",
          isAvailable: true,
          subtitle: "150",
        },

        {
          title: "# of Builds",
          isAvailable: true,
          subtitle: "Unlimited",
        },

        {
          title: "Insights",
          isAvailable: true,
        },

        {
          title: "Access to Our Projections",
          isAvailable: true,
        },

        {
          title: "Team Stack",
          isAvailable: true,
        },

        {
          title: "Min/Max Exposure",
          isAvailable: true,
        },

        {
          title: "Import / Export Projections",
          isAvailable: true,
        },

        {
          title: "Prop Analyzer",
          isAvailable: true,
        },

        {
          title: "Top Plays",
          isAvailable: true,
        },
      ],

      // // monthlyPrice: 'price_1JXfI0Fp5rmgc4CbVtZzjfRP',
      // monthlyPrice: 'price_1JooYTFp5rmgc4CbDqfquCki',
      // // threeMonthPrice: 'price_1JXfK1Fp5rmgc4Cb4hAH6k2e',
      // threeMonthPrice: 'price_1Jp715Fp5rmgc4CbYTfOTaNM',
      // // yearlyPrice: 'price_1JXfKfFp5rmgc4CbQMNXHyOB',
      // yearlyPrice: 'price_1Jp71YFp5rmgc4CbAYOH9F9I',
    };
  },

  computed: {
    ...mapState("NbaModule", ["customerSession", "portal"]),
    ...mapState("userModule", ["userStatus", "sessionWOTrialData"]),

    computedHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 2500;

        default:
          return 1030;
      }
    },
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    freeModel() {
      const utmSource = this.$route.query.utm_source || "unknown";
      const utmMedium = this.$route.query.utm_medium || "unknown";
      const utmCampaign = this.$route.query.utm_campaign || "unknown";
      const utmTerm = this.$route.query.utm_term || "unknown";
      const utmContent = this.$route.query.utm_content || "unknown";

      const priceID =
        this.toggle_exclusive === 0
          ? process.env.VUE_APP_FREE_WEEKLY_PRICE
          : this.toggle_exclusive === 1
          ? process.env.VUE_APP_FREE_MONTHLY_PRICE
          : process.env.VUE_APP_FREE_YEARLY_PRICE;

      if (!localStorage.getItem("stripe_customer_id")) {
        this.$router.push({
          name: "SignUpForm",
          params: { price_id: priceID },
          query: {
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign,
            utm_term: utmTerm,
            utm_content: utmContent,
          },
        });
      }
      // else {
      //   //? check for user status...
      //   this.$store
      //     .dispatch('userModule/getUserStatus', {
      //       userId: localStorage.getItem('user'),
      //     })
      //     .then(() => {
      //       let obj = {
      //         stripe_customer_id: localStorage.getItem('stripe_customer_id'),
      //         price_id: priceID,
      //         type: utmSource,
      //       };
      //         if (this.userStatus.data.istrial == '1') {
      //           // call without trial api....
      //           this.$store
      //             .dispatch('userModule/createSeesionWithoutTrial', obj)
      //             .then(() => {
      //               let path = this.sessionWOTrialData.session['url'];
      //               console.log('sessionWOTrialData', path);
      //               location.href = path;
      //             });
      //         } else {
      //       this.$store.dispatch('NbaModule/createSession', obj).then(() => {
      //         //* if alreday subscrided...
      //         if (this.customerSession.length == 0) {
      //           this.goToPortal();
      //         } else {
      //           let path = this.customerSession.session['url'];
      //           console.log('customerSession', path);
      //           location.href = path;
      //         }
      //       });
      //         }
      //     });
      // }
    },

    premiumModel() {
      const utmSource = this.$route.query.utm_source || "unknown";
      const utmMedium = this.$route.query.utm_medium || "unknown";
      const utmCampaign = this.$route.query.utm_campaign || "unknown";
      const utmTerm = this.$route.query.utm_term || "unknown";
      const utmContent = this.$route.query.utm_content || "unknown";
      const priceID =
        this.toggle_exclusive === 0
          ? process.env.VUE_APP_PREMIUM_WEEKLY_PRICE
          : this.toggle_exclusive === 1
          ? process.env.VUE_APP_PREMIUM_MONTHLY_PRICE
          : process.env.VUE_APP_PREMIUM_YEARLY_PRICE;

      if (!localStorage.getItem("stripe_customer_id")) {
        this.$router.push({
          name: "SignUpForm",
          params: { price_id: priceID },
          query: {
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign,
            utm_term: utmTerm,
            utm_content: utmContent,
          },
        });
      } else {
        //? check for user status...
        this.$store
          .dispatch("userModule/getUserStatus", {
            userId: localStorage.getItem("user"),
          })
          .then(() => {
            let obj = {
              stripe_customer_id: localStorage.getItem("stripe_customer_id"),
              price_id: priceID,
              type: utmSource,
            };
            //   if (this.userStatus.data.istrial == '1') {
            //     // call without trial api....
            //     this.$store
            //       .dispatch('userModule/createSeesionWithoutTrial', obj)
            //       .then(() => {
            //         let path = this.sessionWOTrialData.session['url'];
            //         console.log('sessionWOTrialData', path);
            //         location.href = path;
            //       });
            //   } else {
            this.$store.dispatch("NbaModule/createSession", obj).then(() => {
              //* if alreday subscrided...
              // if (this.customerSession.length == 0) {
              //   this.goToPortal();
              // } else {
              let path = this.customerSession.session["url"];
              console.log("customerSession", path);
              location.href = path;
              // }
            });
            //   }
          });
      }
    },

    platinumModel() {
      const utmSource = this.$route.query.utm_source || "unknown";
      const utmMedium = this.$route.query.utm_medium || "unknown";
      const utmCampaign = this.$route.query.utm_campaign || "unknown";
      const utmTerm = this.$route.query.utm_term || "unknown";
      const utmContent = this.$route.query.utm_content || "unknown";
      const priceID =
        this.toggle_exclusive === 0
          ? process.env.VUE_APP_PLATINUM_WEEKLY_PRICE
          : this.toggle_exclusive === 1
          ? process.env.VUE_APP_PLATINUM_MONTHLY_PRICE
          : process.env.VUE_APP_PLATINUM_YEARLY_PRICE;

      if (!localStorage.getItem("stripe_customer_id")) {
        this.$router.push({
          name: "SignUpForm",
          params: { price_id: priceID },
          query: {
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign,
            utm_term: utmTerm,
            utm_content: utmContent,
          },
        });
      } else {
        //? check for user status...
        this.$store
          .dispatch("userModule/getUserStatus", {
            userId: localStorage.getItem("user"),
          })
          .then(() => {
            let obj = {
              stripe_customer_id: localStorage.getItem("stripe_customer_id"),
              price_id: priceID,
              type: utmSource,
            };
            //   if (this.userStatus.data.istrial == '1') {
            // call without trial api....
            //   this.$store
            //     .dispatch('userModule/createSeesionWithoutTrial', obj)
            //     .then(() => {
            //       let path = this.sessionWOTrialData.session['url'];
            //       console.log('sessionWOTrialData', path);
            //       location.href = path;
            //     });
            //   } else {
            this.$store.dispatch("NbaModule/createSession", obj).then(() => {
              //* if alreday subscrided...
              // if (this.customerSession.length == 0) {
              //   this.goToPortal();
              // } else {
              let path = this.customerSession.session["url"];
              console.log("customerSession", path);
              location.href = path;
              // }
            });
            //   }
          });
      }
    },

    async goToPortal() {
      // debugger;
      let obj = {
        stripe_customer_id: localStorage.getItem("stripe_customer_id"),
      };
      await this.$store.dispatch("NbaModule/createPortal", obj);
      let path = this.portal.data.url;
      location.href = path;
    },
  },
};
</script>

<style lang="scss" scoped>
.style-1 {
  del {
    text-decoration: none;
    position: relative;
    &:before {
      content: " ";
      display: block;
      width: 150%;
      border-top: 2px solid rgba(red, 0.8);
      height: 15px;
      position: absolute;
      bottom: 0;
      left: -10px;
      transform: rotate(-7deg);
    }
  }
}
.discount-text {
  position: relative;
  right: -100%;
  top: -65px;
}

.logo {
  margin: -60px;
}

// .cornerbadge {
//   width: 250px;
//   height: 250px;
//   background: #ff0000;
//   border-radius: 100%;
//   border: 11px solid #fff;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   text-align: center;
//   color: #fff;
//   position: absolute;
//   z-index: 9;
//   left: -80px;
//   top: -80px;
// }
// .cornerbadge h4 {
//   left: 20px;
//   position: relative;
//   line-height: normal;
//   font-size: 24px;
//   top: 21px;
// }

.cornerbadge h4 span {
  display: block;
  font-weight: normal;
}
// @media (max-width: 767px) {
.cornerbadge {
  position: inherit;
  background: #ef4b4b;
  border: none;
  width: 100%;
  height: auto;
  padding: 10px 8px;
  border-radius: 0;
  text-align: center;
  color: white;
  display: block;
  left: 0;
  top: 0;
}
.cornerbadge h4 {
  left: 0;
  top: 0;
  font-size: 18px;
  width: 100%;
  display: block;
}
.cornerbadge h4 span {
  display: initial;
  margin-left: 4px;
}
.cornerbadge h4 span br {
  display: none;
}
// }

.fdo-card {
  transition: all 0.3s ease-in-out 0s;
  border-radius: 12px;
}

.fdo-card:hover {
  transform: translateY(-10px);
  box-shadow: 0px 8px 30px 0px rgba(111, 163, 6, 0.15);
}

.fdo-card:hover .img-container {
  transform: rotate(360deg);
}

.manage:hover {
  cursor: pointer;
  color: rgb(35, 233, 240);
}
</style>
